import React from 'react';
import {useSelector} from 'react-redux';
import {Grid, Paper} from '@mui/material';
import PassageirosEstimados from './passageiros';
import PeriodosHeadDashboard from '../../components/periodos';

const Passageiros = () => {
  const {campanhaSelected, cidadeSelected} = useSelector((store) => store.Toolbar);

  return (
    <Grid id="page-container" container>
      <PeriodosHeadDashboard />
      <Paper sx={styles.graphContainer}>
        <PassageirosEstimados campanha={campanhaSelected} campanhaCidade={cidadeSelected} />
      </Paper>
    </Grid>
  );
};

const styles = {
  graphContainer: {
    minHeight: 'calc(100vh - 115px)',
    width: 'inherit'
  }
};

export default Passageiros;
